import { render, staticRenderFns } from "./CargoForm.vue?vue&type=template&id=754bfd1c&"
import script from "./CargoForm.vue?vue&type=script&lang=js&"
export * from "./CargoForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports